// extracted by mini-css-extract-plugin
module.exports = {"main-component":"rebuildFeature_main-component__2OjPX"};